import getConfig, { setConfig } from "next/config";

const {
    publicRuntimeConfig: originalPublicRuntimeConfig,
    serverRuntimeConfig: originalServerRuntimeConfig
} = getConfig();

let actualPublicRuntimeConfig = originalPublicRuntimeConfig;
let loggedInPublicRuntimeConfig;

const publicRuntimeConfigHandler: ProxyHandler<Record<string, never>> = {
    ownKeys(target: Record<string, never>) {
        return Object.keys(actualPublicRuntimeConfig);
    },
    get(obj: Record<string, never>, prop: string) {
        return actualPublicRuntimeConfig[prop];
    },
    getOwnPropertyDescriptor(target: Record<string, never>, prop: string) {
        return { configurable: true, enumerable: true };
    }
};
const publicRuntimeConfigProxy = new Proxy({}, publicRuntimeConfigHandler);

function replaceNextJSPublicRuntimeConfigWithProxy() {
    setConfig({
        serverRuntimeConfig: originalServerRuntimeConfig,
        publicRuntimeConfig: publicRuntimeConfigProxy
    });
}

export async function setPublicRuntimeConfigToSecuredConfig() {
    if (!loggedInPublicRuntimeConfig) {
        let sensitivePublicRuntimeConfig;

        if (typeof window !== `undefined`) {
            const apiPublicRuntimeConfig = await fetch(`/api/config`);

            sensitivePublicRuntimeConfig = await apiPublicRuntimeConfig.json();
        } else {
            ({ loggedInConfig: sensitivePublicRuntimeConfig } =
                originalServerRuntimeConfig);
        }

        loggedInPublicRuntimeConfig = sensitivePublicRuntimeConfig;
    }

    actualPublicRuntimeConfig = loggedInPublicRuntimeConfig;
}

replaceNextJSPublicRuntimeConfigWithProxy();
